import { configureStore } from "@reduxjs/toolkit";
import dataReducer from "./updateData";

export const store = configureStore({
  reducer: { data: dataReducer },
});

// Inferir los tipos de `RootState` y `AppDispatch`
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
